import {UserPreference} from "@/models/system/user/UserPreference";
import {StartupConfig} from "@/models/system/StartupConfig";

export class GeneralResponse{
    statusCode: number;
    statusDescription: string;

    constructor(code?:number, description?:string) {
        this.statusCode = code ?? -1;
        this.statusDescription = description ?? "";
    }
}

export class TokenResponse extends GeneralResponse{
    token:string = "";
}

export class ChangelogResponse extends GeneralResponse {
    log:string = "";
}

export class StartupConfigResponse extends GeneralResponse{
    customerName:string = ""
    enabledFeatures:Array<string> = []
    defaultPreferences:Array<UserPreference> = []
    idCode:string = ""
    identityUrl:string = ""
    ssoType:number = 1
}
